/*
 * @Author: lbh
 * @Date: 2021-09-11 14:40:56
 * @LastEditors: lbh
 * @LastEditTime: 2025-09-11 03:20:39
 * @Description:餐牌頁 邏輯方法
 */

import util from "@/js/util/util";
import K from "@/js/util/loca_key";
import i18n from "@/i18n";
import logan from "@/js/util/logan";
import { Message, MessageBox } from "element-ui";
import { Toast, Dialog } from "vant";
import {
  sendSms,
  smsLogin,
  smsRegister,
  googleLogin,
  googleBindPhone,
  googleBindPassword,
} from "@/js/api/system/api";
import { addMemberAddress, updateMemberAddress } from "@/js/api/address/api";

import { _ as storageData } from "@/js/util/storage";

import {
  findFoodCombo,
  checkZiquLimit,
  checkOrderLimit,
} from "@/js/api/restaurant/api";
let setting = {
  smsIsSend: false, // 短信 是否請求中
  isPc: false, // 是否是 pc
  smsSendClick: false, // 是否 點擊了 發送驗證阿媽
};
let I = {
  init(e) {
    setting.isPc = e;
  },
  // 提示
  showMessage(text, type, back = () => {}) {
    if (setting.isPc) {
      Message({
        message: text,
        type: type,
        onClose: () => {
          back();
        },
        duration: 1000,
      });
    } else {
      Toast({
        message: text,
        onClose: () => {
          back();
        },
      });
    }
  },
  /**
   * 展示 加載中
   * @param {*} t true / false
   * @param {*} back  pc 回調
   * 1 主頁面 寫一個  showLoading(t=true){this.allLoading = t;}
   * 2 同一個頁面 I.showLoading(true/false,()=>{this.showLoading(true/false)})
   * 3 組件內 I.showLoading(true/false,()=>{this.$emit('showLoading',true/false)})
   */
  showLoading(t = true, back = () => {}) {
    if (setting.isPc) {
      back(t);
    } else {
      if (t) {
        Toast.loading({
          message: i18n.t('common.Loading_'),
          duration: 0,
          forbidClick: true,
        });
      } else {
        Toast.clear();
      }
    }
  },
  /**
   * 公共的 弹窗组件
   * @param {string} title 标题
   * @param {string} content 内容
   * @param {string} confirmButtonText 确认按钮文字
   * @param {string} cancelButtonText 取消按钮文字
   * @param {function} confirmBack 确认回调
   * @param {function} cancelBack 取消回调
   */
  showDialog(
    title,
    content,
    confirmButtonText,
    cancelButtonText,
    confirmBack,
    cancelBack
  ) {
    if (setting.isPc) {
      // element 弹窗
      if (confirmButtonText && cancelButtonText) {
        MessageBox.confirm(content, title, {
          confirmButtonText: confirmButtonText,
          cancelButtonText: cancelButtonText,
          customClass: "pc-el-confirm",
        })
          .then(() => {
            if (typeof confirmBack == "function") confirmBack();
          })
          .catch(() => {
            if (typeof cancelBack == "function") cancelBack();
          });
      } else {
        MessageBox.alert(content, title, {
          confirmButtonText: confirmButtonText,
          customClass: "pc-el-alert",
          callback: (action) => {
            if (typeof confirmBack == "function") confirmBack();
          },
        });
      }
    } else {
      if (confirmButtonText && cancelButtonText) {
        console.log(this.ThemeColor);
        // vant 取消 确认 弹窗
        Dialog.confirm({
          title: title,
          message: content,
          cancelButtonText: confirmButtonText,
          confirmButtonText: cancelButtonText,
          confirmButtonColor: "black",
          // cancelButtonColor: this.ThemeColor || ""
        })
          .then(() => {
            if (typeof cancelBack == "function") cancelBack();
          })
          .catch(() => {
            if (typeof confirmBack == "function") confirmBack();
          });
      } else {
        // vant 确认弹窗
        Dialog.alert({
          title: title,
          message: content,
          confirmButtonText: confirmButtonText,
        }).then(() => {
          if (typeof confirmBack == "function") confirmBack();
        });
      }
    }
  },
  loginFun: {
    setMemberLogin(data = {}, brandId = "") {
      let memberInfo = data.memberInfo || {};
      let dense_token = data.dense_token || data.token || "";
      if (dense_token) {
        util.token.set(dense_token);
      }
      if (memberInfo && memberInfo.id) {
        util.userInfoFun.set(memberInfo, brandId);
      }
      return {
        memberInfo,
        dense_token,
      };
    },
    getGoogleErrorMessage(result = {}, fallbackKey = "login.googleLoginFailed") {
      let raw = result.raw || result || {};
      let errCode = raw.errCode || result.errCode || "";
      let codeMap = {
        "LOGIN.GOOGLE.FAIL": "login.googleLoginFailed",
        "LOGIN.GOOGLE.BIND_EXPIRED": "login.googleBindExpired",
        "LOGIN.GOOGLE.BIND_BUSY": "login.googleBindBusy",
        "LOGIN.GOOGLE.MEMBER_NOT_FOUND": "login.googleMemberNotFound",
        "LOGIN.GOOGLE.ACCOUNT_ALREADY_BOUND": "login.googleAccountAlreadyBound",
        "LOGIN.GOOGLE.MEMBER_ALREADY_BOUND_OTHER":
          "login.googleMemberAlreadyBoundOther",
      };
      if (errCode && codeMap[errCode]) {
        return i18n.t(codeMap[errCode]);
      }
      return raw.errorMsg || raw.errMsg || i18n.t(fallbackKey);
    },
    googleLogin(params = {}) {
      return new Promise((resolve, reject) => {
        googleLogin(params)
          .then((res) => {
            let status = res.status || "";
            if (status == "NEED_BIND") {
              let bindData = {
                ...(res.data || {}),
                brandId: params.brandId || "",
                provider: "GOOGLE",
                sourceScene: params.sourceScene || "",
                webSource: params.webSource || "",
                loginClick: params.loginClick || 0,
                goClick: params.goClick || "",
              };
              storageData.googleLoginParams.set(bindData);
              resolve({
                success: true,
                status: "NEED_BIND",
                data: bindData,
                raw: res,
              });
              return;
            }

            if (res.success || status == "SUCCESS") {
              resolve({
                success: true,
                status: "SUCCESS",
                data: res.data || {},
                raw: res,
              });
              return;
            }

            resolve({
              success: false,
              status: status || "FAILED",
              errCode: res.errCode || "",
              raw: res,
            });
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    googleBindPhone(params = {}) {
      return new Promise((resolve, reject) => {
        googleBindPhone(params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    googleBindPassword(params = {}) {
      return new Promise((resolve, reject) => {
        googleBindPassword(params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    /**
     * 發送驗證阿媽
     * @param {*} phone 電話
     * @param {*} countryId 區域碼
     * @param {*} back 回調
     * @returns true | false
     */
    sendSms(phone, obj, success, error) {
      if (setting.smsIsSend) return;
      phone = phone.toString();

      if (!phone) {
        I.showMessage(i18n.t('common.Enter_a_correct_Phone_Number'), "error");
        success(false);
        return;
      }
      let params = {};
      params.type = 1;
      let countryId = obj;
      if (typeof obj == "object") {
        countryId = obj.countryId;
        params.type = obj.type || 1;
      }
      // 香港, 澳門, 新加坡, 都是8位數  大陸是 11
      if (countryId == 1 || countryId == 2 || countryId == 4) {
        if (phone.length != 8) {
          I.showMessage(i18n.t('common.Enter_a_correct_Phone_Number'), "error");
          if (typeof success == "function") success(false);
          return;
        }
      } else if (countryId == 3) {
        if (phone.length != 11) {
          I.showMessage(i18n.t('common.Enter_a_correct_Phone_Number'), "error");
          if (typeof error == "function") error(false);
          return;
        }
      }
      params.countryId = countryId;
      params.phone = phone;
      setting.smsIsSend = true;
      sendSms(params)
        .then((res) => {
          if (res.code == "1" || res.success) {
            setting.smsIsSend = false;
            setting.smsSendClick = true;
            I.showMessage(i18n.t('common.msgPushSuccess'), "success");
            if (typeof success == "function") success(true);
          } else {
            setting.smsIsSend = false;
            setting.smsSendClick = false;
            let msg = res.errorMsg || res.errMsg;
            if (msg) I.showMessage(msg, "error");
            if (typeof success == "function") success(false);
          }
        })
        .catch((err) => {
          if (typeof error == "function") error();
        });
    },
    /**
     * 登錄
     * @param {*} phone 電話
     * @param {*} countryId 區域碼
     * @param {*} code 驗證碼
     * @param {*} check 是否同意協議
     * @param {*} back 回調
     */
    login(phone, countryId, code, check, smsIsPush, back = () => {}) {
      let params = {};
      phone = phone.toString();
      code = code.toString();
      if (!phone || !code || !check || !smsIsPush || !setting.smsSendClick) {
        return;
      }
      if (!phone) {
        I.showMessage(i18n.t('common.Enter_a_correct_Phone_Number'), "error");
        back(false);
        return;
      }
      // 香港, 澳門, 新加坡, 都是8位數  大陸是 11
      if (countryId == 1 || countryId == 2 || countryId == 4) {
        if (phone.length != 8) {
          I.showMessage(i18n.t('common.Enter_a_correct_Phone_Number'), "error");
          back(false);
          return;
        }
        params.smsType = "accessYouSmsManager";
      } else if (countryId == 3) {
        if (phone.length != 11) {
          I.showMessage(i18n.t('common.Enter_a_correct_Phone_Number'), "error");
          back(false);
          return;
        }
        params.smsType = "webChineseSmsManager";
      }
      if (!code || (code && code.length != 6)) {
        I.showMessage(i18n.t('common.Verification_code_error'), "error");
        return;
      }

      params.phone = phone;
      params.code = code;
      params.brandId = localStorage.getItem(K.brand_id);
      // cid 1 hk, 2 mo , 3 cn , 4 sgp
      params.countryId = countryId;
      smsLogin(params).then((res) => {
        if (res.success) {
          let data = res.data,
            memberInfo = data.memberInfo,
            dense_token = data.dense_token || data.token;
          util.token.set(dense_token);
          util.userInfoFun.set(memberInfo, params.brandId);
          I.showMessage(i18n.t('common.loginSuccess'), "success");
          back(true);
        } else {
          // 用戶未註冊
          if (res.errCode == "LOGIN.0007") {
            // 前往註冊
            this.register(params, back);
          } else if (res.errCode == "SMS.0001") {
            I.showMessage(
              i18n.t('login.SMS_verification_code_error'),
              "error"
            );
            back(false);
          } else if (res.errCode == "LOGIN.0020") {
            I.showMessage(
              i18n.t(
                'login.Member_login_error_times_too_many_please_try_again_later'
              ),
              "error"
            );
            back(false);
          } else if (res.errCode == "LOGIN.0005") {
            I.showMessage(
              i18n.t(
                'login.Your_account_has_been_suspended_please_contact_customer_service_email_'
              ),
              "error"
            );
            back(false);
          } else if (res.errCode == "LOGIN.0006") {
            I.showMessage(
              i18n.t(
                'login.Your_account_hasexpired_please_contact_customer_service_email_'
              ),
              "error"
            );
            back(false);
          } else {
            I.showMessage(res.errMsg, "error");
            back(false);
          }
        }
      });
    },
    /**
     * 註冊
     * @param {*} params 參數
     * @param {*} back 回調
     */
    register(params, back) {
      params.sex = 0;
      smsRegister(params)
        .then((res) => {
          if (res.success) {
            let data = res.data,
              memberInfo = data.memberInfo;
            util.userInfoFun.set(memberInfo, params.brandId);
            I.showMessage(i18n.t('common.loginSuccess'), "success");
            back(true);
          } else {
            back(false);
          }
        })
        .catch((err) => {});
    },
    /**
     * 退出登錄
     * @param {*} back 回調
     */
    loginOut(back) {
      if (setting.isPc) {
        MessageBox.confirm(i18n.t('common.Confirm_logout_'), i18n.t('common.Warm_prompt'), {
          confirmButtonText: i18n.t("Confirm"),
          cancelButtonText: i18n.t("Cancel"),
          customClass: "pc-el-confirm",
        })
          .then(() => {
            util.userInfoFun.clear(back);
          })
          .catch(() => {});
      } else {
        Dialog.confirm({
          title: i18n.t('common.Warm_prompt'),
          message: i18n.t('common.Confirm_logout_'),
          cancelButtonText: i18n.t("Confirm"),
          confirmButtonText: i18n.t("Cancel"),
          confirmButtonColor: "black",
          cancelButtonColor: this.ThemeColor,
        })
          .then(() => {
            // on confirm
          })
          .catch(() => {
            util.userInfoFun.chear(back);
          });
      }
    },
  },
  menus: {
    // 獲取 logo
    getLogo(logoImgs = "") {
      try {
        if (logoImgs) {
          let logos = JSON.parse(logoImgs);
          for (let i = 0; i < logos.length; i++) {
            if (logos[i].type == 3) {
              logoImgs = logos[i].imgUrl;
              break;
            }
          }
        }
      } catch (error) {
        logoImgs = "";
      }

      return logoImgs;
    },
    //  校驗食品
    checkSummary(foods, menuType, restId) {
      let foodsCopy = util.cloneObject(foods);
      for (let i in foodsCopy) {
        let f_ = foodsCopy[i],
          foods_ = f_.foods;
        for (let j in foods_) {
          let fo_ = foods_[j];
          // 校驗 餐種是否合格,
          if (!util.isArrayContains(fo_.foodSummary, menuType)) {
            foods[i].foods.splice(j, 1);
          }
          // 校驗食品關聯餐廳id 是否合格
          if (fo_.restaurantId != restId) {
            foods[i].foods.splice(j, 1);
          }
        }
      }
      return foodsCopy;
    },
    /**
     * 獲取當前狀態 以及 是否可以點餐
     * result.f true 表示不可點, false表示可點
     */
    getShopStatus(menuType, openStatus) {
      let result = {};
      result.f = true;
      if (menuType != 7 && menuType != 1) {
        result.f = false;
        return result;
      }
      if (openStatus == 0) {
        // 商戶休息中
        result.t = i18n.t('common.Shop_closed');
      } else if (openStatus == 2) {
        // 商戶繁忙中 -不可接單
        result.t = i18n.t('common.Shop_in_Busy_delivery_service_not_available_in_this_moment');
      } else if (openStatus == 4) {
        //
        result.t = i18n.t('common.Service_not_available_at_the_moment');
      } else {
        let shipanyStatus = sessionStorage.getItem(K.shipany_status);
        if (menuType == 1 && !util.isNull(shipanyStatus)) {
          if (shipanyStatus == "0") {
            result.t = i18n.t('common.Takeaway_service_is_not_open');
          } else if (shipanyStatus != "1") {
            result.t = i18n.t('common.Not_in_the_scope_of_delivery');
          } else {
            result.f = false;
          }
        } else {
          result.f = false;
        }
      }
      return result;
    },
    /**
     * 獲取 當前食品在 訂單 和 購物車中的總數量
     * @param {array} id 購物車數據
     * @param {array} id 掃碼點餐 訂單數據
     * @param {int} id 食品id
     * @param {int} type 類型, 不傳表示其他, 傳 1 表示 掃碼點餐 整單限制
     */
    getNowNumber(shopCartDatas = [], orderData = [], id, type) {
      let number = 0;
      for (let i = 0; i < shopCartDatas.length; i++) {
        if (shopCartDatas[i].productId == id) {
          number += shopCartDatas[i].number;
        }
      }
      if (type == "1") {
        // 掃碼點餐 額外訂單內數量
        let foods = orderData.foods;
        if (foods) {
          for (let i = 0; i < foods.length; i++) {
            if (foods[i].productId == id && foods[i].status == 0) {
              number += foods[i].number;
            }
          }
        }
      }
      return number;
    },
    /**
     * 點擊 加
     * @param {*} foodsData 餐牌
     * @param {*} shopCartDatas 購物車數據
     * @param {*} orderData 掃碼點餐訂單數據
     * @param {*} person 人數
     * @param {*} pindex 父級
     * @param {*} index 自己
     * @param {*} menuType 點餐類型
     * @param {*} openStatus 餐廳狀態
     * @param {*} isf 是否是購物車加減
     * @param {*} size 購物車 裡的 第幾個
     * @returns {foodsData,shopCartDatas,isCombo="0普通食品,1跟,2選",isNone="true啥也不幹"}
     */
    plusEvent(
      foodsData = [],
      shopCartDatas = [],
      orderData = [],
      person = 1,
      pindex,
      index,
      menuType,
      openStatus,
      isf,
      size
    ) {
      // 這裡判斷食品限制等
      let error = {
        foodsData: [],
        shopCartDatas: [],
        isCombo: 0,
        isNone: true,
      };
      // 判斷是否休息中
      let result = this.getShopStatus(menuType, openStatus);
      if (result.f) {
        return error;
      }

      //  這裡判斷 加 選 跟
      let foodGroup = foodsData[pindex]; // 拿到 食品組
      let food = foodGroup.foods[index]; // 拿到 當前 食品
      // 判斷 是否已售罄
      if (food.invisible == 2) {
        return error;
      }
      if (food.invisible == 3) {
        return error;
      }
      // 判斷估清
      if (menuType == 1) {
        if (food.surplusNum == 0 && food.remainingNumber > 0) {
          return error;
        }
        let num = 0; //購物車數量
        for (let i = 0; i < shopCartDatas.length; i++) {
          let scd = shopCartDatas[i];
          if (scd.productId == food.id) {
            num += scd.number;
          }
        }
        if (
          food.surplusNum > 0 &&
          num >= food.surplusNum &&
          food.remainingNumber > 0
        ) {
          return error;
        }
        if (
          food.surplusNum > 0 &&
          num + 1 >= food.surplusNum &&
          food.remainingNumber > 0
        ) {
          food.isDisable = true;
        }
      }

      // 判斷 食品限制
      let limitType = food.limitType, // 限制類型, 1 每單, 2 整單
        limitAmount = food.limitAmount, // 限制比列 0 不限制,  !0 , limitAmount * person
        allAmount = util.Math.multiply(limitAmount, person), // 總限制比列
        allNumber = this.getNowNumber(shopCartDatas, orderData, food.id), // 總 數量
        allNumber_ = this.getNowNumber(shopCartDatas, orderData, food.id, "1");

      if (limitType == 1 && limitAmount > 0) {
        if (person > 0 && allAmount == allNumber) {
          I.showMessage(i18n.t('common.Max_Number'), "error");
          return error;
        }
        if (allNumber + 1 == allAmount) {
          foodsData[pindex].foods[index].limitFlag = true;
        }
      } else if (limitType == 2 && limitAmount > 0) {
        if (person > 0 && allAmount <= allNumber_) {
          I.showMessage(i18n.t('common.Max_Number'), "error");
          return error;
        }
        if (allNumber + 1 == allAmount) {
          foodsData[pindex].foods[index].limitFlag = true;
        }
      }
      // 判斷 食品組限制 食品組限制, 只對 無限制食品負責
      let groupLimitType = foodGroup.limitType, //  組限制類型 1 每單, 2 整單
        groupLimitAmount = foodGroup.limitAmount, // 組限制比列 0 不限制,  !0 , limitAmount * person
        groupLimitCount1 = util.ifNull(foodGroup.limitCount1, 0), // 當前食品組, 每單限制已點數量
        groupLimitCount2 = util.ifNull(foodGroup.limitCount2, 0), // 當前食品組, 整單限制已點數量
        allGroupAmount = util.Math.multiply(groupLimitAmount, person);
      if (groupLimitType == 1 && limitType == 0 && groupLimitAmount > 0) {
        if (groupLimitCount1 + 1 > allGroupAmount) {
          I.showMessage(i18n.t('common.Over_maximum_order_quantity'), "error");
          return error;
        } else {
          if (util.isNull(foodGroup.limitCount1))
            foodsData[pindex].limitCount1 = 0;
          foodsData[pindex].limitCount1 += 1;
          if (foodsData[pindex].limitCount1 == allGroupAmount) {
            foodsData[pindex].limitFlag = true;
          }
        }
      } else if (
        groupLimitType == 2 &&
        limitType == 0 &&
        groupLimitAmount > 0
      ) {
        if (groupLimitCount2 + 1 > allGroupAmount) {
          I.showMessage(i18n.t('common.Over_maximum_order_quantity'), "error");
          return error;
        } else {
          if (util.isNull(foodGroup.limitCount2))
            foodsData[pindex].limitCount2 = 0;
          foodsData[pindex].limitCount2 += 1;
          if (foodsData[pindex].limitCount2 == allGroupAmount) {
            foodsData[pindex].limitFlag = true;
          }
        }
      }

      let automod = food.automod,
        itemCounts = food.itemCounts;
      if (automod == 1 && itemCounts > 0) {
        // 選
        // 判斷是否是購物車加減
        if (isf) {
          return this.joinShopCart(
            foodsData,
            shopCartDatas,
            pindex,
            index,
            null,
            size
          );
        } else {
          return { foodsData: [], shopCartDatas: [], isCombo: 2 };
        }
      } else if (automod == 0 && itemCounts > 0) {
        // 跟
        // 調用細項接口, 查出細項後進行加入購物車操作
        // 判斷 購物車裡有沒得這個食品
        let f = false;
        for (let i = 0; i < shopCartDatas.length; i++) {
          let data = shopCartDatas[i];
          if (data.productId == food.id) {
            // 匹配到了
            f = true;
            break;
          }
        }
        if (f)
          return this.joinShopCart(
            foodsData,
            shopCartDatas,
            pindex,
            index,
            null,
            size
          );
        else {
          return { foodsData: [], shopCartDatas: [], isCombo: 1 };
        }
      } else {
        //普通食品
        // 直接加入購物車
        return this.joinShopCart(
          foodsData,
          shopCartDatas,
          pindex,
          index,
          null,
          size
        );
      }
    },
    /**
     * 食品減
     */
    minusEvent(foodsData, shopCartDatas, pindex, index, size) {
      let foodGroup = foodsData[pindex]; // 拿到 食品組
      let food = foodGroup.foods[index]; // 拿到 當前 食品
      for (let i = 0; i < shopCartDatas.length; i++) {
        let shopData = shopCartDatas[i];
        let f = size > 0 ? size == i : true;
        if (shopData.productId == food.id && f) {
          let number = shopData.number; // 當前數量
          if (number == 1) {
            shopCartDatas.splice(i, 1);
          } else {
            shopData.number--;
            let itemDetail = shopData.itemDetail;
            for (let j = 0; j < itemDetail.length; j++) {
              let itemD = itemDetail[j][0];
              let number2 = itemD.number;
              let y_num2 = util.Math.divide(number2, number); // 實際數量
              itemDetail[j][0].number = util.Math.multiply(
                y_num2,
                shopData.number
              );
              // 第三級
              let itemDetail3 = itemD.itemDetail;
              if (itemDetail3) {
                for (let h = 0; h < itemDetail3.length; h++) {
                  let number3 = itemDetail3[h].number;
                  let y_num3 = util.Math.divide(number3, number);
                  itemDetail3[h].number = util.Math.multiply(
                    y_num3,
                    shopCartDatas[i].number
                  );
                }
              }
            }
          }
          break;
        }
      }
      // 限制 回歸
      let groupLimitType = foodGroup.limitType, //  組限制類型 1 每單, 2 整單
        groupLimitAmount = foodGroup.limitAmount; // 組限制比列 0 不限制,  !0 , limitAmount * person
      if (groupLimitType == 1 && food.limitType == 0 && groupLimitAmount > 0) {
        foodsData[pindex].limitCount1 -= 1;
      } else if (
        groupLimitType == 2 &&
        food.limitType == 0 &&
        groupLimitAmount > 0
      ) {
        foodsData[pindex].limitCount2 -= 1;
      }
      // 估清 回歸
      foodsData[pindex].foods[index].isDisable = false;
      foodsData[pindex].limitFlag = false;
      foodsData[pindex].foods[index].limitFlag = false;
      foodsData[pindex].foods[index].number--;
      foodsData[pindex].number--;
      return { foodsData, shopCartDatas };
    },
    /**
     * 計算優惠金額
     */
    getPreferentialPrice(price, preferentialPrice) {
      if (preferentialPrice > 0) {
        if (price - preferentialPrice > 0) {
          price = util.Math.subtract(price, preferentialPrice);
          preferentialPrice = 0;
        } else {
          preferentialPrice = util.Math.subtract(preferentialPrice, price);
          price = 0;
        }
      } else {
        price = price;
      }
      return { price, preferentialPrice };
    },
    /**
     * * 食品 加入購物車 -- 只做加入購物車
     * @param {array} foodsData 餐牌數據
     * @param {array} shopCartDatas 購物車數據
     * @param {int} pindex 食品組下標
     * @param {int} index 食品下標
     * @param {object} combo 食品細項
     * @param {int}  size 購物車中的順序
     * @param {int} isCombo 2 表示 選
     */
    joinShopCart(
      foodsData,
      shopCartDatas,
      pindex,
      index,
      combo,
      size,
      isCombo
    ) {
      let foodGroup = foodsData[pindex]; // 拿到 食品組
      let food = foodGroup.foods[index]; // 拿到 當前 食品
      // 先判斷購物車中是否存在此食品, 如果存在, 直接 number++;
      let flag = false;
      let total = 0;
      if (isCombo != 2) {
        for (let i = 0; i < shopCartDatas.length; i++) {
          let data = shopCartDatas[i];
          let f = size > 0 ? size == i : true;
          if (data.productId == food.id && f) {
            // 匹配到了
            let number = shopCartDatas[i].number;
            shopCartDatas[i].number++;
            total = util.Math.add(
              util.Math.multiply(
                shopCartDatas[i].price,
                shopCartDatas[i].number
              ),
              total
            );
            let items = shopCartDatas[i].itemDetail;
            for (let j = 0; j < items.length; j++) {
              let itemDetail = items[j][0];
              let number2 = itemDetail.number;
              let y_num2 = util.Math.divide(number2, number); // 實際數量
              items[j][0].number = util.Math.multiply(
                y_num2,
                shopCartDatas[i].number
              );
              total = util.Math.add(
                util.Math.multiply(items[j][0].price, items[j][0].number),
                total
              );
              // 第三級
              let itemDetail3 = itemDetail.itemDetail;
              if (itemDetail3) {
                for (let h = 0; h < itemDetail3.length; h++) {
                  let number3 = itemDetail3[h].number;
                  let y_num3 = util.Math.divide(number3, number);
                  itemDetail3[h].number = util.Math.multiply(
                    y_num3,
                    shopCartDatas[i].number
                  );
                  total = util.Math.add(
                    util.Math.multiply(
                      itemDetail3[h].price,
                      itemDetail3[h].number
                    ),
                    total
                  );
                }
              }
            }
            flag = true;
            shopCartDatas[i].total = util.Math.divide(
              total,
              shopCartDatas[i].number
            );
            break;
          }
        }
      }

      if (flag) {
        foodsData[pindex].number = foodsData[pindex].number + 1;
        foodsData[pindex].foods[index].number =
          foodsData[pindex].foods[index].number + 1;
        shopCartDatas = this.filterDishShort(shopCartDatas);
        return { foodsData, shopCartDatas };
      }

      let cartD = {};
      // 选的独特的逻辑
      if (isCombo == 2) {
        // * 生成第一級
        cartD = this.getShopCartFoodItem(combo, 1, pindex, index);
        // * 拿到總金額
        total = util.Math.add(combo.price, total);
        // * 拿到必選
        let mustComboData = combo.top;
        let cartDItemDetail = [];
        // * 循環必選
        for (let i in mustComboData) {
          let cbo = mustComboData[i];
          // * 優惠金額
          let preferentialPrice = cbo.preferentialPrice;
          // * 拿到子項
          let cob_itemDetail = cbo.itemDetail;
          // * 循環子項
          for (let j_ in cob_itemDetail) {
            let self_arr = [];
            let cob_item = cob_itemDetail[j_];
            let s_itemDetail = [];
            let price = util.isNull(cob_item.price_)
              ? util.Math.multiply(cob_item.price, cob_item.number)
              : util.Math.multiply(cob_item.price_, cob_item.number); // 得到總金額
            let r = this.getPreferentialPrice(price, preferentialPrice);
            price = r.price;
            preferentialPrice = r.preferentialPrice;
            total = util.Math.add(price, total);
            let self_json = this.getShopCartFoodItem(cob_item, 2, price);
            let cob_item_top = cob_item.top;
            let x_json = {};
            if (!util.isNull(cob_item_top)) {
              for (let x in cob_item_top) {
                let top_x = cob_item_top[x];
                let top_x_itemDetail = top_x.itemDetail;
                if (!util.isNull(top_x_itemDetail)) {
                  for (let u in top_x_itemDetail) {
                    let u_item = top_x_itemDetail[u];
                    total = util.Math.add(u_item.price, total);
                    x_json = this.getShopCartFoodItem(u_item, 3);
                    s_itemDetail.push(x_json);
                  }
                }
              }
            }
            self_json.itemDetail = s_itemDetail;
            self_arr.push(self_json);
            cartDItemDetail.push(self_arr);
          }
        }
        cartD.total = total;
        cartD.itemDetail = cartDItemDetail;
      } else {
        let { cartD: cartD_, total: total_ } = this.setComboDatas(
          food,
          combo,
          pindex,
          index
        );
        cartD = cartD_;
        cartD.total = util.Math.add(total_, total);
      }

      // 更改 餐牌數量
      let groupNumber = util.ifNull(foodGroup.number, 0);
      groupNumber += 1;
      let number = util.ifNull(food.number, 0);
      number += 1;
      // this.
      foodsData[pindex].number = groupNumber;
      // this.
      foodsData[pindex].foods[index].number = number;
      // 加入購物車 數據中
      shopCartDatas.push(cartD);
      shopCartDatas = this.filterDishShort(shopCartDatas);
      return { foodsData, shopCartDatas };
    },

    // * 生成 套餐細項數據
    setComboDatas(food, combo, pindex, index) {
      let cartD = this.getShopCartFoodItem(food, 1, pindex, index);
      let total = food.price; // util.Math.add(food.price, total);
      let itemDetail = [];
      // 存在細項, 開始判斷默認選中細項
      if (combo) {
        cartD.foodType = combo.foodType;
        let oneTops = combo.top; //第二級 組 集合 combo.top
        let oneTopItem = [];
        for (let j = 0; j < oneTops.length; j++) {
          let oneTop = oneTops[j], //第二級 主項 combo.top[0]
            preferentialPrice = oneTop.preferentialPrice,
            twoTops = oneTop.top; //第二級 項集合 combo.top[0].top
          let oneTopJson = {};
          let sNum = 0; //總共選了多少個
          for (let k = 0; k < twoTops.length; k++) {
            let twoTop = twoTops[k]; // 第二級 單項 / 第三級 主項 combo.top[0].top[0]
            let threeTops = twoTop.top; // 第三級 項集合 combo.top[0].top[0].top
            let price = 0;
            if (twoTop.defmodifier == 1) {
              // 默認選中
              let sqty = oneTop.maxqty - sNum; // 剩餘可選數量
              let qty = util.ifNull(twoTop.qty, 1); // 默認選中數量
              if (qty == 0) qty = 1;
              if (sqty - qty < 0) qty = sqty;
              let oPla = 0,
                oNum = 0;
              // 開始遍歷默認選中
              for (let h = 0; h < qty; h++) {
                oneTopJson = {};
                oneTopItem = [];
                price = 0;
                // 計算優惠金額
                let pre = this.getPreferentialPrice(
                  twoTop.price,
                  preferentialPrice
                );
                price = pre.price;
                preferentialPrice = pre.preferentialPrice;
                if (oPla == price && h > 0) {
                  // 重複  需要 ++
                  let itemh = itemDetail[itemDetail.length - 1][0];
                  itemh.number += 1;
                  total = util.Math.add(
                    util.Math.multiply(itemh.price, 1),
                    total
                  );
                  let itemhi = itemh.itemDetail;
                  for (let iih in itemhi) {
                    itemhi[iih].number += 1;
                    total = util.Math.add(
                      util.Math.multiply(itemhi[iih].price, 1),
                      total
                    );
                  }
                } else {
                  oneTopJson = this.getShopCartFoodItem(twoTop, 2, price);
                  total = util.Math.add(
                    util.Math.multiply(oneTopJson.price, oneTopJson.number),
                    total
                  );
                  let twoJson = {};
                  if (threeTops != undefined) {
                    for (let l = 0; l < threeTops.length; l++) {
                      let threeTop = threeTops[l]; // combo.top[0].top[0].top[0]
                      let fourTops = threeTop.top; // combo.top[0].top[0].top[0].top
                      if (fourTops != undefined) {
                        for (let n = 0; n < fourTops.length; n++) {
                          let fourTop = fourTops[n]; //combo.top[0].top[0].top[0].top[0]
                          if (fourTop.defmodifier == 1) {
                            twoJson = this.getShopCartFoodItem(fourTop, 3);
                            total = util.Math.add(
                              util.Math.multiply(fourTop.price, fourTop.number),
                              total
                            );
                            oneTopJson.itemDetail.push(twoJson);
                          }
                        }
                      }
                    }
                  }
                  oneTopItem.push(util.cloneObject(oneTopJson));
                  itemDetail.push(util.cloneObject(oneTopItem));
                  oPla = price;
                }
              }
              sNum += qty;
            }
          }
        }
        cartD.itemDetail = itemDetail;
      }
      // 單項 合計
      cartD.total = total;
      return {
        cartD,
        total,
      };
    },

    /**
     * 生成 购物车主体 食品
     * @param {*} food 食品 / 第二级 / 第三级
     * @param {*} type 1 食品 / 2 第二级 / 3 第三级
     * @param {*} pindex  type 1 -> 父级id ，2 -> price
     * @param {*} index
     * @returns
     */
    getShopCartFoodItem(food, type = 1, pindex, index) {
      let cartD = {};
      cartD.posFid = food.posFid || food.food_fid || food.pos_fid;
      cartD.number = 1;
      cartD.price = food.price;
      // total = util.Math.add(cartD.price, total);
      cartD.productId = food.id;
      cartD.productName = food.foodName || food.food_name || food.name;
      cartD.productName1 = food.foodName1 || food.food_name1 || food.name1;
      cartD.productName2 = food.foodName2 || food.food_name2 || food.name2;
      cartD.lunchboxPrice = food.lunchboxPrice;
      cartD.imageUrl = food.imageUrl;
      cartD.sort = food.fmSeqNo || food.ciSeqNo || food.mSeqNo || 0;
      cartD.foodType = food.foodType;
      cartD.serviceCharge = food.serviceCharge || 0;
      cartD.marketPrice = food.marketPrice || 0; // 原價
      cartD.itemDetail = [];
      cartD.onTime = util.time.format(1, new Date());
      cartD.parentId = food.parentid || "";
      if (!util.isNull(food.modifierType)) {
        cartD.modifierType = food.modifierType;
      }
      if (type == 1) {
        cartD.pindex = pindex;
        cartD.index = index;
        cartD.orderNumber = 0;
        cartD.foodSummary = food.foodSummary;
        cartD.restaurantId = food.restaurantId;
        cartD.ablediscount = food.ablediscount; // 是否可折扣
        cartD.agreement_type = food.agreement_type;
        // * 轉存 起購數量 和 進步數量
        cartD.startQuantity = food.startQuantity || 1;
        cartD.increaseQuantity = food.increaseQuantity || 1;
      } else if (type == 2) {
        cartD.number = food.number || 1;
        cartD.price = util.Math.divide(pindex, food.number);
        cartD.priceStr = util.Math.round(cartD.price);
      } else if (type == 3) {
        cartD.number = food.number || 1;
      }
      return cartD;
    },
    /**
     * 計算總合計
     */
    initTotalAll(shopCartDatas) {
      // 判斷 食品金額 和 數量是否有誤
      for (let i = 0; i < shopCartDatas.length; i++) {
        let data = shopCartDatas[i];
        if (data.number <= 0) {
          shopCartDatas.splice(i, 1);
        }
      }
      // 計算總金額
      let price = 0,
        number = 0;
      let lunchbox = 0;
      for (let i = 0; i < shopCartDatas.length; i++) {
        let data = shopCartDatas[i];
        let p = util.Math.multiply(data.price, data.number); // 計算當前項總金額
        price = util.Math.add(price, p); //計算 總金額
        number = util.Math.add(number, data.number); // 計算總數量
        lunchbox = util.Math.add(
          lunchbox,
          util.Math.multiply(data.number, data.lunchboxPrice)
        ); //計算餐盒費
        let itemDetail = util.ifNull(data.itemDetail, []);
        for (let j = 0; j < itemDetail.length; j++) {
          let item = itemDetail[j][0];
          let ip = util.Math.multiply(item.number, item.price);
          price = util.Math.add(price, ip);
          lunchbox = util.Math.add(
            lunchbox,
            util.Math.multiply(item.number, util.ifNull(item.lunchboxPrice, 0))
          );
          let t_itemDetail = util.ifNull(item.itemDetail, []);
          for (let h = 0; h < t_itemDetail.length; h++) {
            let i_item = t_itemDetail[h];
            let tp = util.Math.multiply(i_item.number, i_item.price);
            price = util.Math.add(price, tp);
            lunchbox = util.Math.add(
              lunchbox,
              util.Math.multiply(
                i_item.number,
                util.ifNull(i_item.lunchboxPrice)
              )
            );
          }
        }
      }
      let totalAll = { number, price };
      localStorage.setItem(K.app_total_all(), JSON.stringify(totalAll));
      localStorage.setItem(K.app_lunch_box(), lunchbox);
      storage.shopCart.set(shopCartDatas);
      // 判斷是否展示下一步
      // this.showNext();
      return { totalAll, showCart: !(number == 0) };
    },
    /**
     * 判斷緩存中是否存在數據, 如果在, 就反向加載
     */
    initLocaData(foodsData, menuType) {
      let shopCartDatas = storage.shopCart.get();
      if (shopCartDatas.length > 0) {
        for (let i = 0; i < shopCartDatas.length; i++) {
          let cart = shopCartDatas[i];
          let pindex = cart.pindex,
            index = cart.index;
          // 先判斷是否是 補差價
          if (cart.posFid == "-1111") {
            shopCartDatas.splice(i, 1);
            i--;
          } else {
            let pdata = foodsData[pindex];
            if (pdata) {
              let f = pdata.foods[index];
              // 判斷 當前緩存中的值 和 餐牌是否一致. 不一致就刪除
              if (f && f.id == cart.productId) {
                foodsData[pindex].foods[index].number = util.Math.add(
                  util.ifNull(foodsData[pindex].foods[index].number, 0),
                  cart.number
                );
                if (!foodsData[pindex].number) {
                  foodsData[pindex].number = 0;
                }
                foodsData[pindex].number += cart.number;
                let foods = foodsData[pindex],
                  food = foods.foods[index],
                  allGroupAmount = util.Math.multiply(
                    foodsData[pindex].limitAmount,
                    this.person
                  ),
                  allNumber = this.getNowNumber(shopCartDatas, [], food.id), // 總 數量
                  allNumber_ = this.getNowNumber(
                    shopCartDatas,
                    [],
                    food.id,
                    "1"
                  ),
                  allAmount = util.Math.multiply(food.limitAmount, this.person);

                // 食品
                if (food.limitType == 1 && allAmount == allNumber) {
                  foodsData[pindex].foods[index].limitFlag = true;
                } else if (food.limitType == 2 && allAmount == allNumber_) {
                  foodsData[pindex].foods[index].limitFlag = true;
                }
                // 食品組
                if (
                  (foods.limitType == 1) & (foods.limitAmount > 0) &&
                  food.limitType == 0
                ) {
                  foodsData[pindex].limitCount1 =
                    util.ifNull(foodsData[pindex].limitCount1, 0) + cart.number;
                  if (foodsData[pindex].limitCount1 == allGroupAmount) {
                    foodsData[pindex].limitFlag = true;
                  }
                } else if (
                  foods.limitType == 2 &&
                  foods.limitAmount > 0 &&
                  food.limitType == 0
                ) {
                  foodsData[pindex].limitCount2 =
                    util.ifNull(foodsData[pindex].limitCount2, 0) + cart.number;
                  if (foodsData[pindex].limitCount2 == allGroupAmount) {
                    foodsData[pindex].limitFlag = true;
                  }
                }
                // 判斷估清
                if (menuType == 1) {
                  let num = 0; //購物車數量
                  for (let i = 0; i < shopCartDatas.length; i++) {
                    let scd = shopCartDatas[i];
                    if (scd.productId == food.id) {
                      num += scd.number;
                    }
                  }
                  if (
                    food.surplusNum > 0 &&
                    num + 1 >= food.surplusNum &&
                    food.remainingNumber > 0
                  ) {
                    food.isDisable = true;
                  }
                }
              } else {
                shopCartDatas.splice(i, 1);
                i--;
              }
            } else {
              shopCartDatas.splice(i, 1);
              i--;
            }
          }
        }
        shopCartDatas = this.filterDishShort(shopCartDatas);
        return { foodsData, shopCartDatas };
      }
      return { foodsData, shopCartDatas: [] };
    },
    /**
     * 購物車內容排序
     */
    filterDishShort(shopCartDatas) {
      let len = shopCartDatas.length;
      for (let i = 0; i < len; i++) {
        for (let j = 0; j < len - 1 - i; j++) {
          if (shopCartDatas[j].pindex > shopCartDatas[j + 1].pindex) {
            let temp = shopCartDatas[j];
            shopCartDatas[j] = shopCartDatas[j + 1];
            shopCartDatas[j + 1] = temp;
          } else if (
            shopCartDatas[j].pindex == shopCartDatas[j + 1].pindex &&
            parseInt(shopCartDatas[j].index) >
              parseInt(shopCartDatas[j + 1].index)
          ) {
            let temp = shopCartDatas[j];
            shopCartDatas[j] = shopCartDatas[j + 1];
            shopCartDatas[j + 1] = temp;
          }
        }
      }
      return shopCartDatas;
    },
    // 清除購物車
    clearShopCart() {
      localStorage.removeItem(K.app_total_all());
      localStorage.removeItem(K.app_lunch_box());
      storage.shopCart.clear();
    },
    /**
     * 分離 必選項 和 加配項
     * @param {*} comboData combo
     * @returns {mustData,otherData}
     */
    initShowData(comboData) {
      let combo_top = comboData.top;
      let must_arr = [],
        should_arr = [];
      for (let i in combo_top) {
        let item = combo_top[i];
        item.show_ = true; // 當是加配項時, false表示不顯示
        item.checked = false;
        if (item.show_type == 2) {
          // 加配項
          item.comboType = "other";
          should_arr.push(item);
        } else {
          //必選項
          item = this.dataProcessing(item);
          must_arr.push(item);
        }
      }
      return { mustData: must_arr, otherData: should_arr };
    },
    /**
     * 數據處理 默認選中和優惠金額
     * @param {Object} e 數據集合
     * @return {e}
     */
    dataProcessing(e) {
      // debugger
      // * 先恢復完整額度，再按既有流程保存原始額度及計算動態餘額。
      e.preferentialPrice = Math.max(
        Number(util.ifNull(e.preferentialPrice, 0)),
        Number(util.ifNull(e.originalPreferentialPrice, 0))
      );
      let top = e.top;
      e.number = 0;
      let itemDetail = [];
      let preferentialPrice = e.preferentialPrice; // 優惠金額
      if (
        util.isNull(e.originalPreferentialPrice) ||
        Number(preferentialPrice) > Number(e.originalPreferentialPrice)
      ) {
        e.originalPreferentialPrice = preferentialPrice;
      }
      e.preferentialPrice_ = preferentialPrice; // 動態 優惠金額
      e.price = 0; // 組是沒有價格的, 清零
      if (e.minqty == 0) {
        e.minqty = 1;
      }
      for (let i = 0; i < top.length; i++) {
        let item = util.cloneObject(top[i]);
        if (item.defmodifier == 1) {
          // 默認選中
          let sqty = e.maxqty - e.number; // 剩餘可選數量
          let qty = util.ifNull(item.qty, 1); // 默認選中數量
          if (qty == 0) qty = 1;
          if (sqty - qty < 0) qty = sqty;
          item.number = 0; //qty; // 設置數量
          top[i].number = qty; // 給總數據 設置數量
          item.index = i; // 設置 次項 在 總數據中的小標
          e.number = util.ifNull(e.number, 0) + qty; // 設置 父級的 數量
          let oldP = 0;
          for (let j = 0; j < qty; j++) {
            let price = item.price;
            if (price - e.preferentialPrice_ >= 0) {
              // 單價 >= 優惠金額
              price = price - e.preferentialPrice_; // 價格優惠
              e.preferentialPrice_ = 0;
            } else {
              e.preferentialPrice_ = e.preferentialPrice_ - price; // 使用了優惠
              price = 0; // 價格歸零
            }
            e.price = util.ifNull(e.price, 0) + price; // 更新 總價
            e.priceStr = util.Math.round(e.price); // 總價的 str 類型
            if (j == 0) {
              item.number = 1;
              item.itemDetail = [];
              item.otherName = "";
              let top_one = item.top;
              if (top_one) {
                for (let t = 0; t < top_one.length; t++) {
                  let top_one_ = top_one[t];
                  top_one_.itemDetail = [];
                  let top_two = top_one_.top;
                  for (let w = 0; w < top_two.length; w++) {
                    let top_two_ = top_two[w];
                    if (top_two_.defmodifier == 1) {
                      item.otherName +=
                        "," + util.setNameByEn(top_two_.name, top_two_.name1);
                      top_two_.isSel = true; // 設為選中
                      top_two_.number = 1;
                      e.price = util.Math.add(
                        util.ifNull(e.price, 0),
                        top_two_.price
                      ); // 更新 總價
                      top_one_.itemDetail.push(top_two_);
                    }
                  }
                }
              }
              itemDetail.push(util.cloneObject(item));
            } else {
              //  判斷 當前項 和 前一項 價格是否相同. 相同就前一項number++
              if (price == oldP) {
                itemDetail[itemDetail.length - 1].number += 1;
                // 這裡細項也要 ++
                let iiitop = itemDetail[itemDetail.length - 1].top;
                if (iiitop) {
                  for (let _i in iiitop) {
                    let iiitem = iiitop[_i].itemDetail;
                    for (let i_ in iiitem) {
                      iiitem[i_].number++;
                      e.price = util.Math.add(
                        util.ifNull(e.price, 0),
                        iiitem[i_].price
                      ); // 更新 總價
                    }
                  }
                }
              } else {
                item.number = 1;
                item.itemDetail = [];
                item.otherName = "";
                let top_one = item.top;
                if (top_one) {
                  for (let t = 0; t < top_one.length; t++) {
                    let top_one_ = top_one[t];
                    top_one_.itemDetail = [];
                    let top_two = top_one_.top;
                    for (let w = 0; w < top_two.length; w++) {
                      let top_two_ = top_two[w];
                      if (top_two_.defmodifier == 1) {
                        item.otherName +=
                          "," + util.setNameByEn(top_two_.name, top_two_.name1);
                        top_two_.isSel = true; // 設為選中
                        top_two_.number = 1;
                        e.price = util.Math.add(
                          util.ifNull(e.price, 0),
                          top_two_.price
                        ); // 更新 總價
                        top_one_.itemDetail.push(top_two_);
                      }
                    }
                  }
                }
                itemDetail.push(util.cloneObject(item));
              }
            }
            oldP = price;
          }
        }
      }
      e.itemDetail = itemDetail;
      return e;
    },
    /**
     * 查詢 外送自取服務
     * @param {*} t  1 外送, 7 自取
     * @param {*} back
     */
    checkOrderLimit(t, shopId, back = () => {}) {
      if (t == 1) {
        checkOrderLimit({
          restaurantId: shopId,
        })
          .then((res) => {
            if (typeof back == "function") {
              if (res.code == -1) {
                back(true);
              } else {
                back(false);
              }
            }
          })
          .catch((err) => {});
      } else if (t == 7) {
        checkZiquLimit({
          restaurantId: shopId,
        })
          .then((res) => {
            if (typeof back == "function") {
              if (res.code == -1) {
                back(true);
              } else {
                back(false);
              }
            }
          })
          .catch((err) => {});
      }
    },
    /**
     * 計算差價
     * @param {*} type 點餐類型
     * @param {*} deliveryCost 第三方接口起送費
     * @param {*} maxBillAmount 餐牌接口 最小q起送費
     * @param {*} lackPrice 差價
     * @param {*} totalAll 總金額 總數量
     */
    getLackPrice(
      type,
      deliveryCost,
      maxBillAmount = 0,
      lackPrice = 0,
      totalAll = {}
    ) {
      let result = {
        show: false, // 是否顯示購物車
        zIndex: 20, // 購物車層級
        nextShow: false, // 是否顯示下一步
        lackPrice_cha: 0, // 差價 差
        lackPriceShow1: false, // 購物車金額 部分 是否顯示 "還需購選$20元食物"
        lackPriceShow2: false, // 購物車 下一步 部分, 是否顯示 "還差$30元起送"
      };
      if (type == 1) {
        if (totalAll.number > 0) {
          // 判斷起送費
          if (!deliveryCost) {
            // 否則, 按照 餐廳數據計算
            deliveryCost = maxBillAmount;
          }
          let cha = util.Math.subtract(deliveryCost, totalAll.price);
          result.lackPrice_cha = cha;
          // 差價邏輯
          if (lackPrice > 0) {
            if (cha > 0) {
              if (totalAll.number > 0 && cha <= lackPrice) {
                // 顯示下一步, 並展示 補差價
                result.lackPriceShow1 = true;
                result.lackPriceShow2 = false;
                result.nextShow = true;
              } else {
                result.lackPriceShow1 = false;
                result.lackPriceShow2 = true;
              }
            } else {
              result.lackPriceShow2 = false;
              result.nextShow = true;
            }
          } else {
            // 正常 起送費邏輯
            if (totalAll.number > 0 && totalAll.price >= deliveryCost) {
              // 現實下一步
              result.lackPriceShow2 = false;
              result.nextShow = true;
            } else {
              result.lackPriceShow2 = true;
            }
          }
        }
      } else {
        if (totalAll.number > 0) {
          result.nextShow = true;
        } else {
          result.nextShow = false;
        }
      }
      return result;
    },
    /**
     * 判斷 是否要生成 補差價食品
     * @param {*} type
     * @param {*} cart
     * @param {*} shopCartDatas
     * @param {*} totalAll
     * @param {*} back
     * @param {*} success
     */
    showLackPrice(type, cart, shopCartDatas, totalAll, success, error) {
      logan.log("用戶點擊下一步:判斷是否序號補差價", logan.types.default);
      if (type == 1 && cart.lackPriceShow1) {
        let t = util.strReplace(
          i18n.t('common.You_still_need_to_make_up_the_difference_of_ONE'),
          "ONE",
          cart.lackPrice_cha
        );
        t += "\n" + i18n.t('common.Whether_to_continue_');
        I.showDialog(
          i18n.t('common.Warm_prompt'),
          t,
          i18n.t("Confirm"),
          i18n.t("Cancel"),
          () => {
            let b = {};
            b.posFid = "-1111";
            b.number = 1;
            b.price = cart.lackPrice_cha;
            b.productId = 0;
            b.productName = i18n.t('common.Make_up_the_difference');
            b.lunchboxPrice = 0;
            b.itemDetail = [];
            let shopData = shopCartDatas;
            shopData.push(b);
            storage.shopCart.set(shopData);
            let total = totalAll;
            total.price = util.Math.add(total.price, cart.lackPrice_cha);
            total.number += 1;
            localStorage.setItem(K.app_total_all(), JSON.stringify(total));
            if (typeof success == "function") success();
          },
          () => {
            if (typeof error == "function") error();
          }
        );
      } else if (typeof success == "function") success();
    },
    /**
     * 獲取 食品協議id
     * @param {*} shopCartDatas 購物車數據
     * @returns
     */
    getFoodResourceList(shopCartDatas) {
      let arr = [];
      for (let i = 0; i < shopCartDatas.length; i++) {
        let shopData = shopCartDatas[i];
        let agreement_type = shopData.agreement_type;
        if (agreement_type != -1 && agreement_type) {
          let f = util.isArrayContains_(arr, agreement_type);
          if (!f) {
            arr.push(agreement_type);
          }
        }
      }
      return arr;
    },
    /**
     * 獲取 訂單頁
     * @param {menuNewParams,scanTable} obj
     * @param {*} isPC
     * @returns
     */
    getGoOrderPath(obj, isPC = false) {
      logan.log(
        "用戶點擊下一步:獲取送單頁信息=>" + JSON.stringify(obj),
        logan.types.default
      );
      // 外送
      if (obj.menuNewParams.type == 1) {
        // 刪除 不在配送範圍的地址
        localStorage.removeItem(K.no_address_id);
        return {
          name: isPC ? "pcDeliveryOrder" : "deliveryOrder",
          params: obj.showTabbar
            ? {
                arg: util.setQueryParams(4),
              }
            : {},
        };
      }
      // 自取
      else if (obj.menuNewParams.type == 7) {
        return {
          name: isPC ? "pcInviteOrder" : "inviteOrder",
          params: obj.showTabbar
            ? {
                arg: util.setQueryParams(4),
              }
            : {},
        };
      }
      // 預點餐
      else if (obj.menuNewParams.type == 5) {
        console.log(111);
      }
      // 固定碼
      else if (obj.menuNewParams.type == 4) {
        let menuType = obj.menuNewParams.menutype;
        if (!util.isNull(menuType)) {
          localStorage.setItem(K.menu_type, menuType);
        }
        // localStorage.setItem(
        //   K.scan_person(obj.scanTable.QR),
        //   obj.scanTable.person
        // );
        let arg = [obj.scanTable.QR, 4];
        localStorage.setItem(
          K.add_order_random(),
          util.getSubmitKey(obj.scanTable.QR)
        );
        return {
          name: "scanOrder",
          params: {
            arg: util.setQueryParams(arg),
          },
        };
      }
      // 掃碼點餐
      else if (obj.menuNewParams.QR) {
        let menuType = obj.menuNewParams.menutype;
        if (!util.isNull(menuType)) {
          localStorage.setItem(K.menu_type, menuType);
        }
        let arg = [obj.menuNewParams.QR, 2];
        localStorage.setItem(K.re_type, 2);
        localStorage.setItem(
          K.add_order_random(),
          util.getSubmitKey(obj.menuNewParams.QR)
        );
        return {
          name: "scanOrder",
          params: {
            arg: util.setQueryParams(arg),
          },
        };
      } else if (obj.menuNewParams.type == 10) {
        // 暫時走外送
        return { name: isPC ? "pcInviteOrder" : "inviteOrder" };
      }
    },
  },
  // ? 食品相關
  food: {
    /**
     * * 獲取 購物車 金額
     * @param {Object} shopCartDatas 購物車數據
     */
    getTatalAmount(shopCartDatas = []) {
      // * 判斷 食品金額 和 數量是否有誤
      for (let i = 0; i < shopCartDatas.length; i++) {
        let data = shopCartDatas[i];
        if (data.number <= 0) {
          shopCartDatas.splice(i, 1);
        }
      }
      // ? 計算總金額
      let price = 0, // * 綜金額
        number = 0; // * 總數量
      // * 總原價
      let allMarketPrice = 0;
      // * 餐盒費
      let lunchbox = 0;
      // * 循環購物車
      for (let i = 0; i < shopCartDatas.length; i++) {
        // * 拿到食品
        let data = shopCartDatas[i];
        // * 當前食品的金額 ( 數量 * 金額)
        let p = util.Math.multiply(data.price, data.number);
        // * 加入到 總金額中
        price = util.Math.add(price, p); //計算 總金額
        // * 原價 累加
        allMarketPrice = util.Math.add(
          allMarketPrice,
          util.Math.multiply(data.marketPrice, data.number)
        );
        // * 總數量 累加
        number = util.Math.add(number, data.number);
        // * 餐盒費累加
        lunchbox = util.Math.add(
          lunchbox,
          util.Math.multiply(data.number, data.lunchboxPrice)
        );
        // * 獲取 套餐
        let itemDetail = util.ifNull(data.itemDetail, []);
        // * 循環套餐項
        for (let j = 0; j < itemDetail.length; j++) {
          // * 拿到套餐, [0] 是因為接口需要這麼搞, 惡心
          let item = itemDetail[j][0];
          // * 拿到套餐金額
          let ip = util.Math.multiply(item.number, item.price);
          // * 累加總金額
          price = util.Math.add(price, ip);
          // * 累加餐盒費
          lunchbox = util.Math.add(
            lunchbox,
            util.Math.multiply(item.number, util.ifNull(item.lunchboxPrice, 0))
          );
          // * 獲取細項
          let t_itemDetail = util.ifNull(item.itemDetail, []);
          // * 循環細項
          for (let h = 0; h < t_itemDetail.length; h++) {
            // * 拿到細項
            let i_item = t_itemDetail[h];
            // * 計算細項金額
            let tp = util.Math.multiply(i_item.number, i_item.price);
            // * 累加金額
            price = util.Math.add(price, tp);
            // * 累加餐盒費
            lunchbox = util.Math.add(
              lunchbox,
              util.Math.multiply(
                i_item.number,
                util.ifNull(i_item.lunchboxPrice)
              )
            );
          }
        }

        // * 減去 碰餐 優惠金額
        price = util.Math.subtract(price, data.mealPrice || 0);
      }
      return {
        price: price,
        number: number,
        allMarketPrice: allMarketPrice,
        lunchbox: lunchbox,
      };
    },

    /**
     * * 計算 套餐細項的數量
     * @param {Object} itemDetail 套餐項
     * @param {Number} num 食品計算前數量
     * @param {Number} toNum 食品計算後的數量
     * @returns 套餐項
     */
    calculateDetailNumber(itemDetail = [], num, toNum) {
      for (let i = 0; i < itemDetail.length; i++) {
        // * 拿到套餐
        let itemD = itemDetail[i][0];
        // * 拿到套餐數量
        let number = itemD.number;
        // * 得到原始基數 (套餐數量 / 食品計算前數量)
        let y_num = util.Math.divide(number, num);
        // * 計算套餐數 => (原始基數 * 食品計算後的數量)
        itemD.number = util.Math.multiply(y_num, toNum);
        let itemDetail_ = itemD.itemDetail;
        if (itemDetail_) {
          for (let j = 0; j < itemDetail_.length; j++) {
            // * 得到細項原始基數 (細項數量 / 食品計算前數量)
            let j_num = util.Math.divide(itemDetail_[j].number, num);
            // * 重新計算細項數量
            itemDetail_[j].number = util.Math.multiply(j_num, toNum);
          }
        }
      }
      return itemDetail;
    },

    /**
     * * 購物車 食品 進行 減法
     * @param {Object} shopCartDatas 購物車數據
     * @param {Number} cartIndex 購物車食品下標
     * @param {Number} foodId 購物車食品id
     * @param {Number} mNum 需要減去的數量
     * @param {Function} _ 回調
     */
    minus(shopCartDatas, cartIndex = -1, foodId, mNum, _) {
      if (cartIndex != -1) {
        let shopData = shopCartDatas[cartIndex];
        // * 表示可以移除
        if (shopData.number == mNum) {
          shopCartDatas.splice(cartIndex, 1);
          _(shopCartDatas);
        } else {
          // * shopData.number > minusNum
          if (shopData.number > mNum) {
            // * 重新計算套餐細項數量
            shopData.itemDetail = this.calculateDetailNumber(
              shopData.itemDetail,
              shopData.number,
              shopData.number - mNum
            );
            // * 食品數量 --
            shopData.number -= mNum;
            _(shopCartDatas);
          } else {
            // * 食品id
            let foodId_ = shopData.productId;
            // * 還需要 - 的食品數量
            let num_ = mNum - shopData.number;
            shopCartDatas.splice(cartIndex, 1);
            // * 遞歸
            this.minus(shopCartDatas, -1, foodId_, num_, _);
          }
        }
      } else {
        for (let i = 0; i < shopCartDatas.length; i++) {
          let shopData = shopCartDatas[i];
          // * 找到 相同的食品
          if (shopData.productId == foodId) {
            let number = shopData.number; // 當前數量
            if (number == mNum) {
              shopCartDatas.splice(i, 1);
              _(shopCartDatas);
              break;
            } else {
              if (number < mNum) {
                shopCartDatas.splice(i, 1);
                this.minus(
                  shopCartDatas,
                  -1,
                  shopData.productId,
                  mNum - number,
                  _
                );
                break;
              } else {
                // * 重新計算套餐細項數量
                shopData.itemDetail = this.calculateDetailNumber(
                  shopData.itemDetail,
                  shopData.number,
                  shopData.number - mNum
                );
                // * 食品數量 --
                shopData.number -= mNum;
                _(shopCartDatas);
                break;
              }
            }
          }
        }
      }
    },
  },
  order: {
    /**
     * 設置 訂單 狀態
     */
    setOrderStatus(list) {
      let result = {};
      let text = "",
        s_text = "",
        color = "",
        content = "",
        allText = "";
      result.f = false;
      //訂單類型#1:餐廳訂單;2:線上外送訂單3:扫码点餐 4:固定二维码订单 5 預點餐  6:積分訂單 7 自取   8 冷鏈 9 新固定二維碼訂單
      // 外送訂單
      if (list.orderType == 2) {
        text = i18n.t('common.Takeout') + " ";
      } else if (list.orderType == 7) {
        // 自取
        text = i18n.t('common.Pick_up') + " ";
      } else if (list.orderType == 8) {
        // 冷鏈
        text = i18n.t('common.Cold_Chain_Delivery') + " ";
      }

      switch (list.status) {
        case 0: // 待确认  未支付
          if (list.orderPayType == 1) {
            s_text = i18n.t('common.Waiting_for_confirmation');
            color = "rgba(0,151,136,1);";
          } else {
            s_text = i18n.t('common.Submit_Order');
            color = "rgba(190,28,66,1);";
          }
          break;
        case 1: // 待确认
          s_text = i18n.t('common.Waiting_for_confirmation');
          color = "rgba(0,151,136,1);";
          break;
        case 2: // 餐厅已确认 制作中
          s_text = i18n.t('common.Business_has_orders');
          color = "rgba(29,183,84,1);";
          break;
        case 3: // 可取餐 派送中
          if (list.orderType == 7) {
            s_text = i18n.t('common.Waiting_for_meal');
            color = "rgba(36,158,247,1);";
          } else {
            s_text = i18n.t('common.Delivery_of');
            color = "rgba(255,148,10,1);";
          }
          break;
        case 4: // 已取餐 已送达
          if (list.orderType == 7) {
            s_text = i18n.t('common.Taken_meals');
            color = "rgba(0,90,224,1);";
          } else {
            s_text = i18n.t('common.It_has_been_served');
            color = "rgba(157,18,0,1);";
          }
          break;
        case 5: // 订单已完成
          s_text = i18n.t('common.Order_completed');
          color = "rgba(60,60,60,1);";
          break;
        case 6: // 訂單已取消
          s_text = i18n.t('common.Order_canceled');
          color = "rgba(134,134,134,1);";
          // 判斷 取消類型 1 商戶取消 2 系統取消 3 用戶取消
          if (list.orderPayType == 2 && !util.isNull(list.payType)) {
            // 用戶取消
            if (list.cancelType == 3) {
              // 退款中
              if (list.refundProgress == 7) {
                text = i18n.t('common.Refund_processing'); // 退款已完结
                color = "rgb(7,193,96)";
                if (list.payType == 1021) {
                  content = i18n.t('common.It_is_expected_that_the_refund_will_be_completed_within_5_7_days'); // 預計5-7天內退款完成
                } else {
                  content = i18n.t('common.The_refund_is_expected_to_be_completed_within_1_3_working_days'); //'預計1-3個工作日內退款完成';
                }
              }
              // 退款已完成
              else if (list.refundProgress == 5) {
                text = i18n.t('common.Refund_completed'); //'退款已完成';
                color = "rgb(7,193,96)";
              }
            } else if (list.cancelType == 1 || list.cancelType == 2) {
              result.f = true;
              // 退款中
              if (list.refundProgress == 7) {
                result.d = i18n.t('common.Refunding'); //'退款中';
                result.dc = "rgb(190,28,66)";
                if (list.payType == 1021) {
                  result.d += `(${i18n.t('common.It_is_expected_that_the_refund_will_be_completed_within_5_7_days')})`; // '(預計5-7天內退款完成)';
                } else {
                  result.d += `(${i18n.t('common.The_refund_is_expected_to_be_completed_within_1_3_working_days')})`; //'(預計1-3個工作日內退款完成)';
                }
              }
              // 退款已完成
              else if (list.refundProgress == 5) {
                result.d = i18n.t('common.Refund_completed'); // '退款完成';
                result.dc = "rgb(7,193,96)";
              }
            }
          }
          break;
        case 7:
          s_text = i18n.t('common.Order_canceled');
          color = "rgba(134,134,134,1);";
          break;
        case 8: // 预约单 已确认
          s_text = i18n.t('common.confirmed');
          color = "rgba(29,183,84,1);";
          break;
        default:
          s_text = i18n.t('common.Takeaway_order');
          color = "";
          break;
      }
      // 當是 app 時, 店鋪訂單單獨處理
      if (this.isApp == "app") {
        // 店鋪訂單
        if (list.orderType == 1) {
          text = i18n.t('common.Shop_Order'); //'店鋪訂單'
        } else if (list.orderType == 3) {
          text = i18n.t('common.Sky_Order'); // "掃碼點餐";
          if (list.status == 5 || list.status == 4)
            s_text = ` ${i18n.t('common.finished')}`; // ' 已完結';
        }
      }
      result.t = text + s_text;
      result.v = content;
      result.c = color;
      result.s_t = s_text;
      result.type = text;
      return result;
    },
    /**
     * 獲取 支付類型
     */
    getPayType(orderData) {
      let text = "";
      if (orderData.payType == 1) {
        text = i18n.t('common.Cash_on_delivery');
      } else {
        text = util.setNameByEn(orderData.payTypeName, orderData.payTypeName2);
        if (util.isNull(text)) {
          text = i18n.t('common.Online_payment');
        }
      }
      return text;
    },
    /**
     * 計算服務費
     * 規則如下
     * ! 1 規則跟父級
     * ! 2 算法和 掃碼點餐 一樣
     * @param {object} shopCartDatas 購物車數據
     * @param {int} type 1 表示 送單顯示, 2 表示 掃碼點餐訂單
     * @param {function} fun 回調
     * @param {} DiscountAndServer: 折扣是否計算服務費 1=是
     * @param {}  xSc: 是否免費服務 0否，1是
     * @param {} memberDiscount  會員折扣
     *
     */
    initServes(
      shopCartDatas,
      type,
      fun = () => {},
      discountAndServer,
      coupon,
      memberDiscount = {}
    ) {
      // 拿到服務費
      let serviceCharge = localStorage.getItem(K.serviceCharge()) || 0;
      // 免服務費時, 服務費置0
      if (coupon && coupon.xsc === 1) serviceCharge = 0;
      let rounding = localStorage.getItem(K.rounding()) || 0; // 規則
      let roundingDecimal = localStorage.getItem(K.roundingDecimal()) || 0; // 小數位
      let itemDecimals = localStorage.getItem(K.itemDecimals()) || 0; // 針對食品單價/合計/折扣 /服務費 /賬單小數/ 顯示的位數小數保留的位數,默認為0
      let allPrice = 0, // * 參與服務費食品總金額
        noPrice = 0; // * 不參與服務費食品總金額
      let disPrice = 0; // * 參與折扣 的 食品總金額
      // 循環 購物車
      for (let i = 0; i < shopCartDatas.length; i += 1) {
        let data = shopCartDatas[i];
        // todo 傻逼后台开发, 改成了 number 可以 < 0
        if (data.number > 0) {
          if (type == 1 || (type == 2 && data.status != 1)) {
            // * 服務費
            if (data.serviceCharge == 1) {
              allPrice = util.Math.add(
                allPrice,
                util.Math.subtract(
                  util.Math.multiply(data.price, data.number),
                  data.mealPrice || 0
                )
              );
            } else {
              noPrice = util.Math.add(
                noPrice,
                util.Math.subtract(
                  util.Math.multiply(data.price, data.number),
                  data.mealPrice || 0
                )
              );
            }
            // * 折扣
            if (data.ablediscount == 1) {
              disPrice = util.Math.add(
                disPrice,
                util.Math.subtract(
                  util.Math.multiply(data.price, data.number),
                  data.mealPrice || 0
                )
              );
            }

            let itemDetail = data.itemDetail || [];
            for (let j = 0; j < itemDetail.length; j += 1) {
              let item = itemDetail[j];
              // todo 傻逼后台开发, 改成了 number 可以 < 0

              if (item.length > 0) item = item[0]; // 適配掃碼點擦
              if (item.number > 0) {
                // * 服務費
                if (data.serviceCharge == 1) {
                  allPrice = util.Math.add(
                    allPrice,
                    util.Math.multiply(item.price, item.number)
                  );
                } else {
                  noPrice = util.Math.add(
                    noPrice,
                    util.Math.multiply(item.price, item.number)
                  );
                }
                // * 折扣
                if (data.ablediscount == 1) {
                  disPrice = util.Math.add(
                    disPrice,
                    util.Math.multiply(item.price, item.number)
                  );
                }
                let itemDetail2 = item.itemDetail || [];
                for (let k = 0; k < itemDetail2.length; k += 1) {
                  let item2 = itemDetail2[k];
                  // * 服務費
                  if (data.serviceCharge == 1) {
                    allPrice = util.Math.add(
                      allPrice,
                      util.Math.multiply(item2.price, item2.number)
                    );
                  } else {
                    noPrice = util.Math.add(
                      noPrice,
                      util.Math.multiply(item2.price, item2.number)
                    );
                  }
                  // * 折扣
                  if (data.ablediscount == 1) {
                    disPrice = util.Math.add(
                      disPrice,
                      util.Math.multiply(item2.price, item2.number)
                    );
                  }
                }
              }
            }
          }
        }
      }

      console.log("disPrice", disPrice);
      console.log("noPrice", noPrice);
      console.log("allPrice", allPrice);
      // * 服務費金額 => 計算後的金額
      let servicePrice = util.Math.divide(
        util.Math.multiply(allPrice, serviceCharge),
        100
      );
      // DiscountAndServer: 折扣是否計算服務費 1=是
      let tst = 0;
      // 優惠券使用數據
      let couponData = {};
      // 服务费 小数位截取
      servicePrice = util.Math.splice(servicePrice, itemDecimals);
      console.log("servicePrice", servicePrice);
      // * 服務費+食品金額
      tst = util.Math.add(
        parseFloat(allPrice), // 合计 保留一位小数
        parseFloat(servicePrice) // 服务费原金额
      );
      console.log("tst", tst);
      // * 加上 其餘食品
      tst = util.Math.add(tst, noPrice);
      console.log("tst", tst);
      // * 計算優惠券 使用前金額 => 參與折扣的食品
      let couponCanUsePrice = disPrice;
      let jAmount = disPrice;
      // * 折扣計算服務費 => 加上服務費
      if (discountAndServer === 1) {
        //  *優惠券可使用金額 + 服務費  => 用戶返回, 作為優惠券選擇列表和查詢可使用優惠券數量 用
        couponCanUsePrice = util.Math.add(disPrice, servicePrice);
        jAmount = util.Math.add(disPrice, servicePrice);
      }

      // ? 優先計算會員折扣
      let memberDiscountResult = util.initMemberDiscount(
        jAmount,
        memberDiscount,
        1,
        itemDecimals
      );
      const { sPrice, yPrice } = memberDiscountResult;
      tst = util.Math.subtract(tst, yPrice);

      // * 使用了優惠券
      if (coupon && coupon.id) {
        // * 折扣計算服務費
        couponData = util.initCounpon(coupon, sPrice, parseInt(itemDecimals));
        tst = util.Math.subtract(tst, couponData.yPrice);
      }
      // * 计算后的金额
      console.log("asdf", tst, rounding, roundingDecimal);
      let zdxs = util.Math.flexd(tst, rounding, roundingDecimal);
      console.log("zdxs", zdxs);
      // * 账单小数
      let ztdst = util.Math.subtract(zdxs, tst); // 賬單小數金額
      console.log("ztdst", ztdst);
      let service = {
        total: util.Math.add(allPrice, noPrice),
        service: `${serviceCharge}%`,
        price: servicePrice, // util.Math.round(servicePrice, 1, 2),
        decimal: ztdst,
        all: zdxs,
        coupon: couponData, // 優惠券使用數據
        couponCanUsePrice: sPrice || 0, // 優惠券可使用金額
        memberDiscountResult: memberDiscountResult,
      };
      console.log("service", service);
      fun(service);
    },

    /**
     * * 計算折扣信息
     */
    initFree(args, _) {
      let {
        restaurantDiscount = {}, // * 餐廳自動折扣
        coupon = {}, // * 優惠券
        distributionFee = 0, // * 配送費
        memberDiscount = {}, // * 會員折扣
        discountMoney = 0, // * 可折扣食品金額
        discountLun = 0, // * 可折扣餐盒費
        unDiscountMoney = 0, // *不可折扣金額
        unDiscountLun = 0, // * 不可折扣餐盒費
        type = "", // * 類型, wm|zq
        discountActive = false, // * 自動折扣 是否開啟
      } = args;

      let totalAmount = 0, // * 總金額
        totalYAmount = 0; // * 總優惠金額

      // ? 優先計算會員折扣
      let memberDiscountResult = util.initMemberDiscount(
        discountMoney,
        memberDiscount,
        2
      );
      // * 拿到 會員折扣後金額  優惠金額
      let { sPrice: memberSPrice, yPrice: memberYPrice } = memberDiscountResult;
      // * 計算總金額
      totalAmount = util.Math.adds(
        memberSPrice,
        discountLun,
        unDiscountMoney,
        unDiscountLun
      );
      let disYPrice = 0, // *自動折扣優惠後金額
        couponYPrice = 0, // * 優惠券優惠後金額
        gCouponAmount = 0, //  * 優惠券計算金額
        disResult = {}, // * 自動折扣結果集
        couponResult = {}; // * 優惠券結果集
      // * 其餘總金額
      let zAmount = util.Math.adds(distributionFee, discountLun);
      // * 拿到 優惠券是否 獨佔 : 0否, 1是
      let couponExclusive = coupon.exclusive || 0;
      // *拿到 餐廳折扣 是否獨佔 : 0否, 1是
      restaurantDiscount = restaurantDiscount || {};
      let restaurantExclusive = restaurantDiscount.exclusive || 0;
      if (restaurantExclusive == 1 && coupon.id) couponExclusive = 1;

      // ? 再計算餐廳自動折扣
      disResult = util.initDiscount(
        restaurantDiscount,
        gCouponAmount,
        memberSPrice,
        distributionFee,
        discountLun,
        type,
        discountActive,
        couponExclusive
      );
      console.log("disResult", disResult);
      if (disResult.show) {
        disResult.active = true;
        // * 優惠券開起來獨佔, 關閉自動折扣
        if (couponExclusive == 1) disResult.active = false;
        gCouponAmount = disResult.gCouponAmount;
        // ? 自動折扣 優惠金額
        disYPrice = disResult.yPrice;
        // ? 計算總金額
        totalAmount = util.Math.adds(
          gCouponAmount,
          disResult.otherPrice,
          unDiscountMoney,
          unDiscountLun
        );
      } else {
        // * 重賦值
        gCouponAmount = disResult.gCouponAmount;
        // * 隱藏自動折扣
        disResult.show = true;
        if (discountActive && !disResult.show) {
          disResult.show = false;
        }
        // * 計算總金額
        totalAmount = util.Math.adds(
          zAmount,
          memberSPrice,
          unDiscountMoney,
          unDiscountLun
        );
      }
      // ? 再計算優惠券
      if (coupon.id) {
        // * 優惠券結果
        couponResult = util.initCounpon(coupon, gCouponAmount);
        // * 顯示優惠券
        if (couponResult.show) {
          // ? 拿到優惠金額
          couponYPrice = couponResult.yPrice;
          // * 優惠券金額 + 自動折扣其餘金額 + 不折扣食品 + 不折扣餐盒費
          totalAmount = util.Math.adds(
            couponResult.price,
            disResult.otherPrice,
            unDiscountMoney,
            unDiscountLun
          );
        }
      }
      totalYAmount = util.Math.adds(memberYPrice, disYPrice, couponYPrice);

      _({
        totalAmount,
        totalYAmount,
        memberDiscountResult,
        disResult,
        couponResult,
      });
    },
  },
  request: {
    /**
     * 查詢 細項
     * @param {*} foodId 食品id
     * @param {function} back 回調
     */
    findFoodComboFun(foodId, back) {
      findFoodCombo({
        foodId,
      }).then((res) => {
        if (res.code == 1) {
          back(res.data);
        } else {
          back(false);
        }
      });
    },
  },
  inviteOrder: {},
  pcCoupon() {},
  pay: {
    pay_: {
      zfb: [8], // 支付寶
      zfbhk: [6], // 支付寶hk
      applePay: [10, 37], // 蘋果支付 37 是默認的
      payme: [1020, 20, 34], // payme 34 默认支付
      googlePay: [1021, 21, 38], // google支付 visa/master
      yedPayZfb: [1022, 22, 39],
      yedPayZfbHk: [1023, 23],
      yedPayZfbPc: [32], // 支付寶pc
      yedPayWx: [30, 31], // 2022-3-22 09:47:17 新增 31 表示默認
      zsk: [1019, 19], // 轉數快
      boc: [1024, 26], // 中銀
      yedPayVisa: [1117, 17],
      yedPayMaster: [1118, 18],
      yedPayDefault: [1025, 25],
      qfH5Pay: [27, 29], // 29 表示 默認
      qfPcPay: [28, 33], // 33 表示 默認
      qfVisaMaster: [40, 41], // 錢方 v/m
      qfZfb: [43, 45], // 錢方 支付寶
      qfZfbHk: [42, 44], // 錢方支付寶 hk
      allinpay: [46, 47, 48, 49, 50, 51], // * Allinpay 支付類型，51 不使用圖標
    },
    /**
     * 得出 支付類型
     * @param {*} payTypes
     * @param {*} amount
     * @returns
     */
    initPayType(payTypes, amount) {
      let isPc = util.IsPC();
      let isSafari = util.isSafari();
      let isSel = false;
      let types = [];
      let check = 0;
      let pay_ = this.pay_;
      for (let i in payTypes) {
        let img = payTypes[i].img || "";
        payTypes[i].show = !isPc;
        let payId = payTypes[i].id;
        if (pay_.zfb.indexOf(payId) > -1) {
          img = require("../../assets/icon/pay/zfblogo@2x.png");
        } else if (pay_.zfbhk.indexOf(payId) > -1) {
          img = require("../../assets/icon/pay/alipayhk@3x.png");
        } else if (pay_.applePay.indexOf(payId) > -1) {
          img = require("../../assets/icon/pay/applepay@2x.png");
          if (!isSafari) {
            payTypes[i].show = false;
          }
        } else if (pay_.payme.indexOf(payId) > -1) {
          img = require("../../assets/icon/pay/payme-logo-red.png");
        } else if (pay_.googlePay.indexOf(payId) > -1) {
          img = require("../../assets/icon/pay/google.png");
          if (isPc || isSafari) {
            payTypes[i].show = true;
            payTypes[i].payName = "Visa/Master";
            payTypes[i].payName2 = "Visa/Master";
            img = require("../../assets/icon/pay/visa.png");
          }
        } else if (pay_.yedPayZfb.indexOf(payId) > -1) {
          img = require("../../assets/icon/pay/zfblogo@2x.png");
        } else if (pay_.yedPayZfbHk.indexOf(payId) > -1) {
          img = require("../../assets/icon/pay/alipayhk@3x.png");
        } else if (pay_.yedPayZfbPc.indexOf(payId) > -1) {
          img = require("../../assets/icon/pay/zfblogo@2x.png");
          payTypes[i].show = isPc;
        } else if (pay_.zsk.indexOf(payId) > -1) {
          img = require("../../assets/icon/pay/zsk.png");
          payTypes[i].show = isPc;
        } else if (pay_.boc.indexOf(payId) > -1) {
          img = require("../../assets/icon/pay/boc.png");
          payTypes[i].show = isPc;
        } else if (pay_.yedPayVisa.indexOf(payId) > -1) {
          img = require("../../assets/icon/pay/visa_.png");
        } else if (pay_.yedPayMaster.indexOf(payId) > -1) {
          img = require("../../assets/icon/pay/master.png");
        } else if (pay_.yedPayDefault.indexOf(payId) > -1) {
          img = require("../../assets/icon/pay/zfblogo@2x.png");
        } else if (pay_.qfH5Pay.indexOf(payId) > -1) {
          img = require("../../assets/icon/pay/wxlogo@2x.png");
        } else if (pay_.qfPcPay.indexOf(payId) > -1) {
          img = require("../../assets/icon/pay/wxlogo@2x.png");
          payTypes[i].show = isPc;
        } else if (pay_.yedPayWx.indexOf(payId) > -1) {
          img = require("../../assets/icon/pay/wxlogo@2x.png");
        } else if (pay_.qfVisaMaster.includes(payId)) {
          img = require("../../assets/icon/pay/qf.png");
        } else if (pay_.qfZfb.includes(payId)) {
          img = require("../../assets/icon/pay/zfblogo@2x.png");
        } else if (pay_.qfZfbHk.includes(payId)) {
          img = require("../../assets/icon/pay/alipayhk@3x.png");
        } else if (pay_.allinpay.includes(Number(payId))) {
          // * Allinpay 沿用現有支付圖示，名稱與備註繼續使用接口返回內容
          const allinpayIcon = {
            46: require("../../assets/icon/pay/alipayhk@3x.png"),
            47: require("../../assets/icon/pay/zfblogo@2x.png"),
            48: require("../../assets/icon/pay/wxlogo@2x.png"),
            49: require("../../assets/icon/pay/octopus.png"),
            50: require("../../assets/icon/pay/google.png"),
            51: "", // * 支付類型 51 不使用圖標
          };
          img = allinpayIcon[Number(payId)];
        } else {
          payTypes[i].show = false;
        }
        // 判斷是否有默認選中
        if (payTypes[i].isdefault == 1 && payTypes[i].show) {
          isSel = true;
          check = payTypes[i].id;
          this.payTypeCheck(payTypes[i].id, amount);
        }
        payTypes[i].img = img;
        if (payTypes[i].show || pay_.applePay.indexOf(payId) > -1) {
          types.push(payTypes[i]);
        }
      }
      // 判斷有沒有 默認選中
      if (!isSel) {
        // 需要選中第一個
        let pay = types[0];
        check = pay.id;
        if (pay_.applePay.includes(Number(check))) {
          for (let i = 0; i < types.length; i++) {
            if (types[i].id != 10 && types[i].id != 37) {
              check = types[i].id;
              break;
            }
          }
        }
        this.payTypeCheck(check, amount);
      }
      return { types: types, check };
    },
    payTypeCheck(id, amount) {
      // 倒計時結束 或者 時間為0
      // 蘋果支付
      if (this.pay_.applePay.includes(Number(id))) {
        // 蘋果支付 最低不低於 4元
        if (amount < 4) {
          Toast(i18n.t('common.Apple_must_pay_more_than_4'));
          return;
        }
      }
    },
  },
  sendSingle: {
    setImg(obj) {
      let result = "";
      if (obj) {
        obj = JSON.parse(obj);
        for (let i = 0; i < obj.length; i++) {
          if (obj[i].type == 2) {
            result = obj[i].imgUrl;
            break;
          }
        }
      }
      return result;
    },
    /**
     *
     * @param {*} d 数据集
     * @param {*} isLogin 是否登录
     * @param {*} address_title 地址
     * @returns 返回结果
     */
    setState(d, isLogin, address_title) {
      let result = {
        f: false,
        t: "",
      };
      if (!isLogin) {
        // 未登錄
        result.f = true;
        result.t = i18n.t('common.Please_enter_address');
      } else if (!address_title) {
        result.f = true;
        result.t = i18n.t('common.Please_enter_address');
      } else {
        if (d.openStatus == 0) {
          // 商戶休息中
          result.t = i18n.t('common.Shop_closed');
          result.f = true;
        } else if (d.openStatus == 2) {
          // 商戶繁忙 不可接單
          result.t = i18n.t('common.Shop_in_Busy_delivery_service_not_available_in_this_moment');
          result.f = true;
        } else if (d.openStatus == 3) {
          // 商戶繁忙 可接單
          result.f = false;
        } else if (d.openStatus == 4) {
          result.t = i18n.t('common.Service_not_available_at_the_moment_please_contact_the_merchant');
          result.f = true;
        } else {
          if (d.shipanyStatus == 0) {
            // 外送服務未開啟
            result.t = i18n.t('common.Takeaway_service_is_not_open');
            result.f = true;
          } else if (d.shipanyStatus != 1) {
            // 不在配送範圍
            result.t = i18n.t('common.Not_in_the_scope_of_delivery');
            result.f = true;
          }
        }
      }
      return result;
    },
  },
  pcAddressList: {
    DataAssembly() {},
    /**
     *  清除地图标记
     * @param {*} markersArray
     */
    clearOverlays(markersArray) {
      if (markersArray && markersArray.length > 0) {
        for (var i = 0; i < markersArray.length; i++) {
          if (markersArray[i]) {
            markersArray[i].setMap(null);
          }
        }
        markersArray.length = 0;
      }
    },
    /**
     *
     * @param {*} myAddress 当前选择的地址信息、userInfo
     * @param {*} isAddress 當前的地址信息
     * @param {*} isPc
     * @param {*} searchText 当前地址
     * @returns
     */
    submitAddress(myAddress, isAddress, isPc, searchText) {
      let params = {};
      let address = myAddress;
      if (util.isNull(address.receiver)) {
        I.showMessage(i18n.t('common.Please_enter_the_name_of_the_consignee'), "error");
        return;
      }
      if (util.isNull(address.phone)) {
        I.showMessage(i18n.t('common.Please_enter_contact_information'), "error");
        return;
      } else if (address.phone.length != 8 && address.phone.length != 11) {
        I.showMessage(
          i18n.t('common.Please_enter_the_correct_contact_information'),
          "error"
        );
        return;
      }
      if (util.isNull(searchText)) {
        I.showMessage(i18n.t('common.Please_choose_the_receiving_address'), "error");
        return;
      }

      if (util.isNull(address.address)) {
        I.showMessage(i18n.t('common.Please_enter_a_detailed_address'), "error");
        return;
      }
      params.receiver = address.receiver;
      params.memberId = localStorage.getItem(K.user_id);
      if (isPc) {
        params.currentAddress = isAddress.address;
        params.dimensionMap = `${isAddress.lng},${isAddress.lat}`;
      } else {
        params.currentAddress = address.currentAddress;
        params.dimensionMap = address.dimensionMap;
      }
      params.isdefault = address.isdefault ? "1" : "0";
      params.address = address.address;
      params.phone = address.phone;
      params.sex = address.sex;
      params.type = 2;
      return { params, address };
    },
    /**
     *
     * @param {*} isEdit 是否编辑
     * @param {*} params 请求数据集
     * @param {*} address 当前选择的地址信息、userInfo
     * @returns
     */
    isEdit(isEdit, params, address, back) {
      // 編輯
      if (isEdit) {
        params.id = address.id;
        updateMemberAddress(params)
          .then((res) => {
            if (res.code == 1) {
              I.showMessage(i18n.t('common.Modified_success'), "success");
              back(address.id);
            }
          })
          .catch((err) => {});
      }
      // 添加
      else {
        addMemberAddress(params)
          .then((res) => {
            if (res.code == 1) {
              I.showMessage(i18n.t('common.Add_success'), "success");
              back(res.id);
            }
          })
          .catch((err) => {});
      }
    },
  },
};

export default I;
